<script setup>
import { computed } from 'vue'
import { SHIP_TYPE } from '@/constants/calculationFieldConstants.ts'
import { useShipApiStore } from '@/stores/shipApi'
import { storeToRefs } from 'pinia'
import { useCalculationStore } from '@/stores/calculation'

const store = useShipApiStore()

const { currentItem, options } = storeToRefs(useCalculationStore())

const fields = computed(() => {
  return options.value.actions.POST ?? {}
})

const typeName = computed(() => {
  const shipTypeField = fields.value['ship_type']
  return (
    shipTypeField?.choices.find((choice) => choice.value === currentItem.value[SHIP_TYPE])
      ?.display_name ?? ''
  )
})
</script>

<template>
  <tr>
    <th class="text-left border-top-grey" colspan="5" style="width: 30%">Type: {{ typeName }}</th>
    <th class="text-center border-left-grey border-top-grey" colspan="2" style="width: 16%">
      Draught [m]
    </th>
    <th class="text-center border-left-grey border-top-grey" colspan="3" style="width: 24%">
      Depth to keel [m]
    </th>
    <th class="text-center border-left-grey border-top-grey" colspan="2" style="width: 16%">
      Parallel body length [m]
    </th>
    <th class="text-center border-left-grey border-top-grey border-right-divider" rowspan="2">
      Validation
    </th>
  </tr>
  <tr>
    <th class="text-center" style="width: 5%"></th>
    <th class="text-center" style="width: 12%">Name</th>
    <th class="text-center" style="width: 8%">Capacity [{{ store.getCapacityUnit }}]</th>
    <th class="border-left-grey text-center" style="width: 9%">Length overall [m]</th>
    <th class="text-center" style="width: 8%">Breadth [m]</th>
    <th class="text-center border-left-grey" style="width: 8%">Laden</th>
    <th class="text-center" style="width: 8%">Ballasted</th>
    <th class="text-center border-left-grey" style="width: 10%">Main deck</th>
    <th class="text-center" style="width: 9%">Forecastle</th>
    <th class="text-center" style="width: 9%">Poop</th>
    <th class="text-center border-left-grey" style="width: 7%">Aftward</th>
    <th class="text-center" style="width: 7%">Forward</th>
  </tr>
</template>
